import React from 'react';
import { connect } from 'react-redux';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';

import DropdownAddStock from './dropdownAddStock';
import NavItemRight from './navItemRight';
import { Link, Redirect } from 'react-router-dom';

import { filter, some, find, remove, chain, zipObject } from 'lodash';

import * as _ from 'lodash';

import { v4 as uuidv4 } from 'uuid';
import icMagnifier from '../../../../assets/img/magnifier.png';

import {
  setCategory,
  saveCategoryRequest,
  setToast,
  setSymbolScroll,
} from '../../../../containers/client/actions';

import { DMNGANH, saveState } from '../../../../lib/storages';
import {
  snapshotRequest,
  stockInfoRequest,
  snapshotRequestSuccess,
} from '../../../../containers/banggia/actions';
import StockSuggest from '../../../select/stockSuggest';
import { WebSocketContext } from '../../../../containers/socket/webSocket';
import {
  makeGetToken,
  makeGetAllStock,
  makeGetCategory,
  makeGetSnapShot,
} from '../../../../lib/selector';
import { setRegSymbol } from '../../../../containers/socket/actions';

import ItemWatchListNew from './itemWatchListNew';
import ItemAddWatchList from './itemAddWatchList';
import { translate } from 'react-i18next';

class NavbarPriceboard extends React.PureComponent {
  static contextType = WebSocketContext;

  componentDidUpdate(preProps) {
    const { symbolDel, symbolAdd } = this.props;

    if (symbolDel && symbolDel !== preProps.symbolDel) {
      console.log(symbolDel);
      this._handleDelStock(symbolDel);
    }

    if (symbolAdd && symbolAdd !== preProps.symbolAdd) {
      console.log(symbolAdd);
      this._handleAddStock(symbolAdd);
    }
  }

  _handleDelStock = (stock) => {
    let ws = this.context;
    const { category, categoryId, setCategory } = this.props;

    let isUpdate = false;

    category.forEach((element) => {
      if (element.id === categoryId) {
        remove(element.value, (o) => o === stock);
        remove(element.pinnedRow, (o) => o === stock);

        const payload = {
          action: 'leave',
          data: stock,
        };
        ws.sendMessage(payload);
        isUpdate = true;
      }
    });

    if (isUpdate) {
      // save to action
      setCategory(category);
      saveState('category', category);
      // this._handleSaveCategory(category);

      this.fetchCategoryData(categoryId);

      const { snapshot, snapshotRequestSuccess } = this.props;
      const snapshotRemove = filter(snapshot, (o) => o.sym !== stock);
      snapshotRequestSuccess(snapshotRemove);
    }
  };

  _handleAddStock = (stock) => {
    let ws = this.context;
    const {
      category,
      categoryId,
      setCategory,
      setToast,
      setRegSymbol,
      setSymbolScroll,
      t,
    } = this.props;

    const categoryGroup = find(
      category,
      (o) => o.type === 'group' && o.path.endsWith('/bang-gia/' + categoryId)
    );

    let isUpdate = false;

    if (categoryGroup) {
      setSymbolScroll(stock);
    } else {
      category.forEach((element) => {
        if (element.id === categoryId) {
          if (element.value.indexOf(stock) > -1) {
            setSymbolScroll(stock);
          } else {
            if (element.value.length > 100) {
              const toastMsg = {
                id: Math.random(),
                msg: 'Danh mục tối đa 100 mã',
                title: t('txt-notice'),
              };
              setToast(toastMsg);

              return;
            }
            element.value.push(stock);
            // regis socket data
            const payload = {
              action: 'join',
              data: stock,
            };
            ws.sendMessage(payload);
            setRegSymbol(stock);

            isUpdate = true;
          }
        }
      });

      if (isUpdate) {
        // save to action
        setCategory(category);
        saveState('category', category);
        this.fetchStockInfo(stock);
      }
    }
  };

  _handleSaveCategory = (_newCategory) => {
    const { token, saveCategoryRequest } = this.props;

    if (!token) return;

    const uuid = uuidv4();
    const resData = {
      group: 'BACK',
      user: token.user,
      session: token.session,
      cmd: 'SET_WAT',
      rqId: uuid,
      channel: 'WTS',
      data: _newCategory,
    };

    saveCategoryRequest(resData);
  };

  fetchStockInfo = (stock) => {
    const { stockInfoRequest } = this.props;
    return stockInfoRequest(stock);
  };

  fetchCategoryData = (categoryId) => {
    const { snapshotRequest, category } = this.props;

    const catalogSelected = find(
      category,
      (o) => o.path && o.path.endsWith('/bang-gia/' + categoryId)
    );

    if (catalogSelected)
      return snapshotRequest(catalogSelected.value.join(','));
    else return null;
  };

  render() {
    const { allStock, category, categoryId, t } = this.props;
    let _grActive, _pathActive;

    const _cloneCategory = _.cloneDeep(category);

    console.log(_cloneCategory);

    const checkCategoryId =
      categoryId && !categoryId.startsWith('nganh-') && _cloneCategory
        ? some(
          _cloneCategory,
            (o) => o.path && o.path.endsWith('/bang-gia/' + categoryId)
          )
        : true;
    if (!checkCategoryId) return <Redirect to="/" />;

    const categoryGroup = filter(_cloneCategory, (o) => o.type === 'group');
    const categoryWatchList = filter(_cloneCategory, (o) => o.type === 'watchlist');
    const _grCtl = chain(categoryGroup)
      .groupBy('groupName')
      .toPairs()
      .map((pair) => zipObject(['groupName', 'groupValue'], pair))
      .value();

    const _wlActive = _.find(categoryWatchList, (o) => o.id === categoryId);

    if (categoryId && categoryId.startsWith('nganh-')) {
      // nganh
      _grActive = find(
        DMNGANH,
        (o) => o && o.path && o.path === '/home/bang-gia/' + categoryId
      );
    } else {
      _grActive = find(_grCtl, (o) =>
        some(o.groupValue, (ol) => ol.path.endsWith('/bang-gia/' + categoryId))
      );

      _pathActive = find(categoryGroup, (o) =>
        o.path.endsWith('/bang-gia/' + categoryId)
      );
    }

    // console.log(_grActive, _pathActive);

    return (
      <Navbar bg="dark" variant="dark" expand="md" className="bt-1-half">
        <Navbar.Collapse id="basic-navbar-nav" className="navbar-priceboard">
          <Nav className="d-flex align-items-center mr-auto">
            <div className="position-relative pr-2 form-inline">
              <StockSuggest
                dataSuggest={allStock}
                addStock={this._handleAddStock}
                classname={'form-add form-control fz-14'}
                placeholder={t('txt-add-symbol')}
              />
              <img src={icMagnifier} className="form-add-img" />
            </div>
            <div
              className={
                'mr-2 dropdown nav-item ' + (_wlActive ? 'active' : '')
              }
            >
              <a className="dropdown-toggle nav-link">
                {`Danh mục ${_wlActive ? '(' + _wlActive?.name + ')' : ''}`}
              </a>
              <div className="dropdown-menu m-0">
                {categoryWatchList &&
                  !!categoryWatchList.length &&
                  categoryWatchList.map((item) => (
                    <ItemWatchListNew
                      key={item.type + '_' + item.id}
                      categoryId={categoryId}
                      record={item}
                    />
                  ))}
                <ItemAddWatchList />
              </div>
            </div>

            {_grCtl &&
              !!_grCtl.length &&
              _grCtl.map((item, index) => {
                if (
                  item.groupName === 'CHUNGQUYEN' ||
                  item.groupName === 'TRAIPHIEU' ||
                  item.groupName === 'PHAISINH'
                ) {
                  return (
                    <Link
                      key={'gr_' + item.groupName + '_' + index}
                      to={item.groupValue[0].path}
                      className={
                        'nav-link mr-2 ' +
                        (item.groupValue[0].path.endsWith(
                          '/bang-gia/' + categoryId
                        )
                          ? 'active'
                          : '')
                      }
                    >
                      {item.groupName === 'CHUNGQUYEN' && t('txt-cw')}
                      {item.groupName === 'PHAISINH' && t('txt-ps')}
                      {item.groupName === 'TRAIPHIEU' && t('txt-tp')}
                      {item.groupName === 'LOLE' && 'Lô lẻ'}
                    </Link>
                  );
                }

                if (item.groupName === 'NGANH') {
                  return (
                    <div
                      key={'gr_' + index}
                      className={
                        'mr-2 dropdown nav-item ' +
                        (_grActive && _grActive.sequence ? 'active' : '')
                      }
                    >
                      <a className="dropdown-toggle nav-link">
                        {`Danh mục ngành ${
                          _grActive && _grActive.sequence
                            ? '(' + _grActive.name + ')'
                            : ''
                        }`}
                      </a>
                      <div className="dropdown-menu m-0">
                        {DMNGANH.map((element, i) => {
                          if (!element.path) return null;

                          return (
                            <Link
                              key={'gr_' + item.sequence + '_' + i}
                              to={element.path}
                              className={
                                'nav-link  ' +
                                (_grActive && element.name === _grActive.name
                                  ? 'active'
                                  : '')
                              }
                            >
                              {element.name}
                            </Link>
                          );
                        })}
                      </div>
                    </div>
                  );
                }

                return (
                  <div
                    key={'gr_' + index}
                    className={
                      'mr-2 dropdown nav-item ' +
                      (_grActive && _grActive.groupName === item.groupName
                        ? 'active'
                        : '')
                    }
                  >
                    <a className="dropdown-toggle nav-link">
                    {`${item.groupName === 'LOLE' ? 'Lô lẻ' : item.groupName} ${
                      _grActive && _grActive.groupName === item.groupName
                        ? '(' + _pathActive.name + ')'
                        : ''
                    }`}
                    </a>
                    <div className="dropdown-menu m-0">
                      {item.groupValue.map((element, i) => (
                        <Link
                          key={'gr_' + item.groupName + '_' + i}
                          to={element.path}
                          className={
                            'nav-link  ' +
                            (element.path.endsWith('/bang-gia/' + categoryId)
                              ? 'active'
                              : '')
                          }
                        >
                          {element.path.indexOf('thoa-thuan') > -1
                            ? t('txt-pt')
                            : element.name}
                        </Link>
                      ))}
                    </div>
                  </div>
                );
              })}
          </Nav>
          <Nav className="d-flex align-items-center">
            <NavItemRight categoryId={categoryId} />
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}

const makeMapStateToProps = () => {
  const getToken = makeGetToken();
  const getAllStock = makeGetAllStock();
  const getCategory = makeGetCategory();
  const getSnapShot = makeGetSnapShot();

  const mapStateToProps = (state) => {
    return {
      token: getToken(state),
      allStock: getAllStock(state),
      category: getCategory(state),
      snapshot: getSnapShot(state),
      symbolDel: state.client.symbolDel,
      symbolAdd: state.client.symbolAdd,
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps, {
  snapshotRequest,
  stockInfoRequest,
  snapshotRequestSuccess,
  setCategory,
  setToast,
  saveCategoryRequest,
  setRegSymbol,
  setSymbolScroll,
})(translate('translations')(React.memo(NavbarPriceboard)));
